import React, { Component } from 'react';
import PDMassStatusUpdate from './PDMassStatusUpdate';
import PDMultiEditBox from './PDMultiEditBox';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService.js';
import PlanningList from '../PlanningItem/PlanningList';
import Link from '../../../Elements/link';
import stringHelper from '../../../Helpers/stringHelper';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import { Paper } from '@mui/material';
import ButtonRow from '../../../Elements/ButtonRow';
import JsxHelper from '../../../Helpers/JsxHelper';
import PlanningDetailsItem from '../../../Domain/PlanningDetailsItem';
import ShownSubPanelsEnum from '../../../Enums/ShownSubPanelsEnum';
import PlanningMain from '../PlanningMain';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import PlanningSearchParams from '../PlanningItem/PlanningSearchParams';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import PlanningDetailListDetailsBox from './PlanningDetailListDetailBox';
import PlanningDetailItemEditBox from './PlanningDetailItemEditBox';
import PlanningDetailItemStatusUpdateBox from './PlanningDetailItemStatusUpdateBox';
import ErrorMessage from '../../../Elements/ErrorMessage';

class PlanningDetailList extends Component
{
  static defaultProps = {
    pricingId: 0,
  };

  constructor (props)
  {
    super(props);

    this.state = {
      pricingId: props.pricingId,
      planningDetailItems: [],
      selected: -1,
      orderBy: 'FieldworkOrderNumber',
      orderDirection: 'Asc',
      allSelected: false,
      shownPanel: ShownPanelsEnum.Search,
      searchItem: new PlanningSearchParams(),
    };
    this.state.searchItem.PricingId = props.pricingId;

    this.showPanel = this.showPanel.bind(this);
    PlanningDetailsItem.clickOnLink = this.clickOnLink.bind(this);
    PlanningDetailsItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    PlanningDetailsItem.selectedStatus = this.selectedStatus.bind(this);
    PlanningDetailsItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  selectAllElements ()
  {
    const selectedStatus = this.state.planningDetailItems.some((item) => item.Selected === false);
    const templist = [ ...this.state.planningDetailItems ];

    if (templist !== undefined && templist.length > 0)
    {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ planningDetailItems: templist });
  }

  selectedStatus ()
  {
    if (this.state.planningDetailItems.some((x) => x.Selected === false))
    {
      return false;
    }
    return true;
  }

  clickOnSelect (item, selected)
  {
    item.Selected = !item.Selected;
    const tempList = [ ...this.state.planningDetailItems ];
    if (tempList !== undefined)
    {
      this.setState({ planningDetailItems: tempList });
    }
  }

  clickOnLink = (item, panelEnumId) =>
  {
    this.setState({
      selected: item.PlanningDetailId,
      selectedItem: item,
      shownPanel: panelEnumId,
    });
  };

  renderShownSubPanel ()
  {
    if (this.state.selected === -1 || !this.state.selectedItem || this.state.shownPanel === ShownSubPanelsEnum.None)
    {
      return null;
    }

    switch (this.state.shownPanel)
    {
      case ShownSubPanelsEnum.Details:
        return (
          <PlanningDetailListDetailsBox
            id={this.state.selected}
            item={this.state.selectedItem}
            cancelHandler={() => this.closeSubPanelHandler(false)}
          />
        );
      case ShownSubPanelsEnum.EditItem:
        return (
          <PlanningDetailItemEditBox
            caption='Edit PlanningDetail Item'
            selectedItem={this.state.selectedItem}
            submitHandler={() => this.closeSubPanelHandler(true)}
            cancelHandler={() => this.closeSubPanelHandler(false)}
          />
        );
      case ShownSubPanelsEnum.StatusUpdate:
        return (
          <PlanningDetailItemStatusUpdateBox
            caption='PlanningDetail Item - Update Status'
            selectedItem={this.state.selectedItem}
            submitHandler={() => this.closeSubPanelHandler(true)}
            cancelHandler={() => this.closeSubPanelHandler(false)}
          />
        );
      default:
        return '';
    }
  }

  renderLinkRow ()
  {
    if (!this.state.planningDetailItems[ 0 ]) return null;
    return (
      <>
        <Link
          linktext={`Planning - Services (${this.state.planningDetailItems[ 0 ].ServiceId})`}
          title='Planning - Services'
          link={<PlanningMain />}
          className='linkrowlink'
          iconName='fa-solid fa-ruler-combined'
          url='planning'
        />
        {JsxHelper.NonBreakableSpace(5)}
        {JsxHelper.Chevron()}
        {JsxHelper.NonBreakableSpace(5)}
        <Link
          linktext={`Planning - Planning Items (${this.state.pricingId})`}
          title='Planning - Planning Items'
          link={<PlanningList serviceId={this.state.planningDetailItems[ 0 ].ServiceId} />}
          className='linkrowlink'
          iconName='fa-solid fa-screwdriver'
          url={`planning_planningList/search?ServiceId=${this.state.planningDetailItems[ 0 ].ServiceId}`}
        />
      </>
    );
  }

  showPanel (panelNameEnumId)
  {
    if (panelNameEnumId === ShownPanelsEnum.Refresh)
    {
      this.refreshList();
      panelNameEnumId = ShownPanelsEnum.None;
    }
    const newId = panelNameEnumId === this.state.shownPanel ? ShownPanelsEnum.None : panelNameEnumId;
    this.setState({
      shownPanel: newId,
    });
  }

  maxPlannedAssignments ()
  {
    return Math.max(...this.state.planningDetailItems.map((item) => item.NumberOfPlannedAssignments));
  }

  renderPanels ()
  {
    return (
      <>
        <ButtonRow
          labels={[ 'MULTI EDIT', 'STATUS UPDATE' ]}
          keys={[ ShownPanelsEnum.MultiEdit, ShownPanelsEnum.MassStatusUpdate ]}
          icons={[ 'fa-solid fa-edit', 'fa-solid fa-pen-alt' ]}
          colors={[ ButtonColorsEnum.Secondary, ButtonColorsEnum.Secondary ]}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.state.shownPanel === ShownPanelsEnum.MassStatusUpdate ? (
          <PDMassStatusUpdate
            clickOnCancel={() => this.showPanel(ShownPanelsEnum.None)}
            submitHandler={(from, to) => this.submitMassStatusUpdate(from, to)}
          />
        ) : null}
        {this.state.shownPanel === ShownPanelsEnum.MultiEdit ? (
          <PDMultiEditBox
            numberOfPlannedAssignments={this.maxPlannedAssignments()}
            submitHandler={(data) => this.submitMultiEdit(data)}
            clickOnCancel={() => this.showPanel(ShownPanelsEnum.None)}
          />
        ) : null}
        {this.renderShownSubPanel()}
      </>
    );
  }

  submitMultiEdit (data)
  {
    const tempItems = this.state.planningDetailItems.filter((item) => item.Selected);

    if (tempItems.length > 0)
    {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        loading: true,
      });
      PlanningDetailsItemService.EditMultiplePlanningDetailItems(tempItems, data)
        .then(() => this.setState({ searchItem: { ...this.state.searchItem } }))
        .catch(() => ErrorMessage.SetErrorMessage('PDL233'));
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  submitMassStatusUpdate (to)
  {
    const tempItems = this.state.planningDetailItems.filter((item) => item.Selected);

    if (tempItems.length > 0)
    {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        loading: true,
      });
      PlanningDetailsItemService.MassStatusUpdate(tempItems, to)
        .then(() => this.setState({ searchItem: { ...this.state.searchItem } }))
        .catch(() => ErrorMessage.SetErrorMessage('PDL251'));
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderInfoRow (first)
  {
    if (!first) return null;
    return (
      <Paper
        elevation={6}
        className='border p-1 m-1'
      >
        <div className='inforow'>
          Country: {first.CountryName}, Opportunity:{' '}
          {first.OpportunityName + stringHelper.toBracket(first.OpportunityId)}, Service:{' '}
          {first.ServiceName + stringHelper.toBracket(first.ServiceId)}
        </div>
      </Paper>
    );
  }

  renderHeader ()
  {
    return (
      <div>
        {this.renderLinkRow()}
        {this.renderInfoRow(this.state.planningDetailItems[ 0 ])}
      </div>
    );
  }

  closeSubPanelHandler (forceRefresh)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      selected: -1,
    });
    if (forceRefresh)
    {
      this.setState({ searchItem: { ...this.state.searchItem } });
    }
  }

  render ()
  {
    return (
      <div
        key='pldijs'
        className='contentwrapper'
      >
        {this.renderHeader()}
        {this.renderPanels()}
        {this.renderShownSubPanel()}
        <TabOfDataTable
          type={PlanningDetailsItem}
          itemTypeName={'planning items'}
          shownPanel={this.state.shownPanel}
          serviceFunction={PlanningDetailsItemService.GetPlanningDetailsItemsByPricingId}
          convertDBItemsFunction={PlanningDetailsItemService.ConvertDBPlanningDetailsItems}
          showSearchStrip={true}
          searchItem={this.state.searchItem}
          itemList={this.state.planningDetailItems}
          isFilterDisabled={true}
          changeOfItemListFunction={(itemList) => this.setState({ planningDetailItems: itemList })}
          errorCode='PDL271'
        />
      </div>
    );
  }
}

export default PlanningDetailList;
